import './UserMenu.scss';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback } from 'react'
import { Dropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import Avatar from '../common/Avatar';
import { useKeycloak } from '@react-keycloak/web';
import Cookies from 'js-cookie';

interface ToggleProps {
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}
export type Ref = HTMLButtonElement;

const CustomToggle = React.forwardRef<Ref, ToggleProps>(({ children, onClick }, ref) => (
  <button
    type="button"
    ref={ref}
    onClick={onClick}
    className="user-menu-toggle"
  >
    {children}
  </button>
));

type Props = {
  className?: string;
}

export default function UserMenu({ className }: Props) {
  const { loggedUser } = useAuth();
  const { keycloak } = useKeycloak();

  const logout = useCallback(() => {
    Cookies.remove(window.__env.AUTH_TOKEN_NAME || "alida-token");
    Cookies.remove(window.__env.AUTH_REFRESH_TOKEN_NAME || "alida-refresh-token");
    Cookies.remove(window.__env.AUTH_USER_NAME || "alida-user");
    keycloak.logout({ redirectUri: window.__env.POST_LOGOUT_REDIRECT_URI });
  }, [keycloak]);

  return (
    <Dropdown className={`user-menu ${className}`}>
      <Dropdown.Toggle as={CustomToggle}>
        <Avatar user={loggedUser} size="xs" />
        <div className="ps-1 ms-2 text-start d-none d-md-block">
          <h6 className="mb-0 lh-1">{loggedUser?.preferred_username}</h6>
          <small className="font-sm text-muted">{loggedUser?.userOrganizationStatus?.current?.name}</small>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu align="end">
        <Dropdown.Item as={Link} to="/account">
          <FontAwesomeIcon icon={solid('user')} fixedWidth />
          <span className="ms-3">Account</span>
        </Dropdown.Item>

        {/* <Dropdown.Divider /> */}

        <Dropdown.Item onClick={logout}>
          <FontAwesomeIcon icon={solid('sign-out')} fixedWidth />
          <span className="ms-3">Logout</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}